import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function SafetyRecommendations() {
    const { t } = useTranslation();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200);
    const navigate = useNavigate();
    const ref3 = useRef(null);
    const ref4 = useRef(null);
    const ref5 = useRef(null);
    const ref6 = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1200);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleClick = (ref) => {
        ref.current?.scrollIntoView({ behavior: 'smooth' });
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <>
            <div className="row" style={isMobile ? { height: "80px", backgroundColor: "#900fc8", marginTop: "-70px", marginBottom: "0px" } :
                { height: "60px", backgroundColor: "#900fc8", marginTop: "-70px", marginBottom: "40px" }}>
                <div className="col">
                </div>
                <div className="col-auto pt-1">
                    <h5 style={{ color: "white", fontWeight: "500", fontSize: isMobile ? "18px" : "22px", marginTop: "15px" }}>{t("SAFETY_FOOTER")}</h5>
                </div>
                <div className="col">
                </div>
            </div>
            <div className={isMobile ? "bg-light" : ""} style={isMobile ? { paddingTop: "40px", marginTop: "-20px", borderRadius: "1.5em" } : {}}>
                <div className={isMobile ? "container mb-6 p-0" : "container mb-6"} style={isMobile ? { width: "90%" } : {}}>
                    {!isMobile ? <div className="card p-4 bg-purple" style={{ borderRadius: "60px", height: "300px", boxShadow:"rgba(29, 58, 83, 0.1) 0px 10px 20px" }}>
                        <div className="row">
                            <div className="col-8 mt-5">
                                <h5 className="text-white ms-4" style={{ color: "black", fontSize: "25px", fontWeight: "500" }}>{t("SAFETY_HEADER")}</h5>
                                <p className="ms-4" style={{ lineHeight: "25px", fontSize: "16px", fontWeight: "500", lineHeight: "25px", color: "white", marginTop: "20px", width: "88%" }}>{t("SAFETY_DETAIL")}</p>
                            </div>
                            <div className="col-auto">
                                <div className="card shadow p-4 mt-5 bg-white" style={{ position: "absolute", marginTop: "40px", width: "350px" }}>
                                    <h6 className="mb-3" style={{ fontWeight: "600", color: "black" }}>{t("IN_THIS_PAGE")} </h6>
                                    <div className="d-flex justify-content-between mb-2">
                                        <p className="mb-1" onClick={() => handleClick(ref3)} style={{ flexGrow: 1, fontSize: "15px", color: "#900fc8", cursor: "pointer" }}>{t("SAFETY_NEVER_CLICK_LINKS")}
                                        </p>
                                        <div style={{ alignSelf: "flex-end" }}>
                                            <svg style={{ marginBottom: "5px" }} width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8.91016 19.92L15.4302 13.4C16.2002 12.63 16.2002 11.37 15.4302 10.6L8.91016 4.07996" stroke="#900fc8" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2">
                                        <p className="mb-1" onClick={() => handleClick(ref4)} style={{ flexGrow: 1, fontSize: "15px", color: "#900fc8", cursor: "pointer" }}>{t("SAFETY_P3")}
                                        </p>
                                        <div style={{ alignSelf: "flex-end" }}>
                                            <svg style={{ marginBottom: "5px" }} width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8.91016 19.92L15.4302 13.4C16.2002 12.63 16.2002 11.37 15.4302 10.6L8.91016 4.07996" stroke="#900fc8" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2">
                                        <p className="mb-1" onClick={() => handleClick(ref5)} style={{ flexGrow: 1, fontSize: "15px", color: "#900fc8", cursor: "pointer" }}>{t("SAFETY_P14")}
                                        </p>
                                        <div style={{ alignSelf: "flex-end" }}>
                                            <svg style={{ marginBottom: "5px" }} width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8.91016 19.92L15.4302 13.4C16.2002 12.63 16.2002 11.37 15.4302 10.6L8.91016 4.07996" stroke="#900fc8" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>

                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <p className="mb-1" onClick={() => handleClick(ref6)} style={{ flexGrow: 1, fontSize: "15px", color: "#900fc8", cursor: "pointer" }}>{t("SAFETY_P15")}
                                        </p>
                                        <div style={{ alignSelf: "flex-end" }}>
                                            <svg style={{ marginBottom: "5px" }} width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8.91016 19.92L15.4302 13.4C16.2002 12.63 16.2002 11.37 15.4302 10.6L8.91016 4.07996" stroke="#900fc8" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> :
                        <div>
                            <div className="card  bg-purple" style={{ borderRadius: "30px", height: "auto", marginBottom: isMobile ? "35px" : "300px", marginTop: "-20px", boxShadow:"rgba(29, 58, 83, 0.1) 0px 10px 20px" }}>
                                <div className="row">
                                    <div className="col p-5">
                                        <h5 className="text-white mb-3" style={{ color: "black", fontSize: "22px", fontWeight: "500" }}>{t("SAFETY_HEADER")}</h5>
                                        <p className="mt-2" style={{ lineHeight: "22px", fontSize: "15px", color: "white" }}>{t("SAFETY_DETAIL")}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="card shadow p-4 bg-white" style={{ marginTop: "-15px" }}>
                                        <h6 className="mb-3" style={{ fontWeight: "600" }}>{t("IN_THIS_PAGE")} </h6>
                                        <div className="d-flex justify-content-between mb-2">
                                            <p className="mb-1" onClick={() => handleClick(ref3)} style={{ flexGrow: 1, fontSize: "15px", color: "#900fc8", cursor: "pointer" }}>{t("SAFETY_NEVER_CLICK_LINKS")}
                                            </p>
                                            <div style={{ alignSelf: "flex-end" }}>
                                                <svg style={{ marginBottom: "5px" }} width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.91016 19.92L15.4302 13.4C16.2002 12.63 16.2002 11.37 15.4302 10.6L8.91016 4.07996" stroke="#900fc8" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <p className="mb-1" onClick={() => handleClick(ref4)} style={{ flexGrow: 1, fontSize: "15px", color: "#900fc8", cursor: "pointer" }}>{t("SAFETY_P3")}
                                            </p>
                                            <div style={{ alignSelf: "flex-end" }}>
                                                <svg style={{ marginBottom: "5px" }} width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.91016 19.92L15.4302 13.4C16.2002 12.63 16.2002 11.37 15.4302 10.6L8.91016 4.07996" stroke="#900fc8" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <p className="mb-1" onClick={() => handleClick(ref5)} style={{ flexGrow: 1, fontSize: "15px", color: "#900fc8", cursor: "pointer" }}>{t("SAFETY_P14")}
                                            </p>
                                            <div style={{ alignSelf: "flex-end" }}>
                                                <svg style={{ marginBottom: "5px" }} width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.91016 19.92L15.4302 13.4C16.2002 12.63 16.2002 11.37 15.4302 10.6L8.91016 4.07996" stroke="#900fc8" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>

                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <p className="mb-1" onClick={() => handleClick(ref6)} style={{ flexGrow: 1, fontSize: "15px", color: "#900fc8", cursor: "pointer" }}>{t("SAFETY_P15")}
                                            </p>
                                            <div style={{ alignSelf: "flex-end" }}>
                                                <svg style={{ marginBottom: "5px" }} width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.91016 19.92L15.4302 13.4C16.2002 12.63 16.2002 11.37 15.4302 10.6L8.91016 4.07996" stroke="#900fc8" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}

                    <div ref={ref3} className="card bg-transparent border p-0" style={isMobile ? { maxWidth: "1120px", marginLeft: "auto", marginRight: "auto", marginTop: "20px" } : { maxWidth: "1120px", marginLeft: "auto", marginRight: "auto", marginTop: "50px" }}>
                        <div className="card-header bg-transparent border-bottom p-4">
                            <h5 className="mb-0" style={{ fontWeight: "bold", fontSize: "20px", color: "black" }}>  {t("SAFETY_NEVER_CLICK_LINKS")}</h5>
                        </div>
                        <div className="card-body p-4 pt-0">
                            <div className="mt-4">
                                <p className="mb-0" style={{ lineHeight: "25px", fontSize: "16px" }}>
                                    {t("SAFETY_P1")}
                                </p>
                                <p className="mb-0 mt-3" style={{ lineHeight: "25px", fontSize: "16px" }}>
                                    {t("SAFETY_P2")}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div ref={ref4} className="card bg-transparent border p-0" style={{ maxWidth: "1120px", marginLeft: "auto", marginRight: "auto", marginTop: "20px" }}>
                        <div className="card-header bg-transparent border-bottom p-4">
                            <h5 className="mb-0" style={{ fontWeight: "bold", fontSize: "20px", color: "black" }}>  {t("SAFETY_P3")}</h5>
                        </div>
                        <div className="card-body p-4 pt-0">
                            <div className="mt-4">
                                <p className="mb-0" style={{ lineHeight: "25px", fontSize: "16px" }}>
                                    {t("SAFETY_P4")}
                                </p>
                                <p className="mb-0 mt-3" style={{ lineHeight: "25px", fontSize: "16px" }}>
                                    {t("SAFETY_P5")}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div ref={ref5} className="card bg-transparent border p-0" style={{ maxWidth: "1120px", marginLeft: "auto", marginRight: "auto", marginTop: "20px" }}>
                        <div className="card-header bg-transparent border-bottom p-4">
                            <h5 className="mb-0" style={{ fontWeight: "bold", fontSize: "20px", color: "black" }}>  {t("SAFETY_P14")}</h5>
                        </div>
                        <div className="card-body p-4 pt-0">
                            <div className="mt-4">
                                <p className="mb-0" style={{ lineHeight: "25px", fontSize: "16px", fontWeight: "bold" }}>
                                    {t("SAFETY_P6")}
                                </p>
                                <p className="mb-0" style={{ lineHeight: "25px", fontSize: "16px" }}>
                                    {t("SAFETY_P7")}
                                </p>
                                <p className="mb-0 mt-3" style={{ lineHeight: "25px", fontSize: "16px", fontWeight: "bold" }}>
                                    {t("SAFETY_P8")}
                                </p>
                                <p className="mb-0" style={{ lineHeight: "25px", fontSize: "16px" }}>
                                    {t("SAFETY_P9")}
                                </p>
                                <p className="mb-0 " style={{ lineHeight: "25px", fontSize: "16px" }}>
                                    {t("SAFETY_P10")}
                                </p>
                                <p className="mb-0 mt-3" style={{ lineHeight: "25px", fontSize: "16px", fontWeight: "bold" }}>
                                    {t("SAFETY_P11")}
                                </p>
                                <p className="mb-0 " style={{ lineHeight: "25px", fontSize: "16px" }}>
                                    {t("SAFETY_P12")}
                                </p>
                                <p className="mb-0 mt-3" style={{ lineHeight: "25px", fontSize: "16px" }}>
                                    {t("SAFETY_P13")}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div ref={ref6} className="card bg-transparent border p-0" style={{ maxWidth: "1120px", marginLeft: "auto", marginRight: "auto", marginTop: "20px" }}>
                        <div className="card-header bg-transparent border-bottom p-4">
                            <h5 className="mb-0" style={{ fontWeight: "bold", fontSize: "20px", color: "black" }}>  {t("SAFETY_P15")}</h5>
                        </div>
                        <div className="card-body p-4 pt-0">
                            <div className="mt-4">
                                <p className="mb-0" style={{ lineHeight: "25px", fontSize: "16px", fontWeight: "bold" }}>
                                    {t("SAFETY_P16")}
                                </p>
                                <p className="mb-0" style={{ lineHeight: "25px", fontSize: "16px" }}>
                                    {t("SAFETY_P17")}
                                </p>
                                <p className="mb-0 mt-3" style={{ lineHeight: "25px", fontSize: "16px", fontWeight: "bold" }}>
                                    {t("SAFETY_P18")}
                                </p>
                                <p className="mb-0 " style={{ lineHeight: "25px", fontSize: "16px" }}>
                                    {t("SAFETY_P19")}
                                </p>
                                <p className="mb-0 mt-3" style={{ lineHeight: "25px", fontSize: "16px", fontWeight: "bold" }}>
                                    {t("SAFETY_P20")}
                                </p>
                                <p className="mb-0 " style={{ lineHeight: "25px", fontSize: "16px" }}>
                                    {t("SAFETY_P21")}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}